// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.1
//   protoc               v4.23.4
// source: common/users.proto

/* eslint-disable */
import type { FileAttachment } from "./attachment";
import type { Money } from "./money";

export const UserType = {
  UNKNOWN_TYPE: "UNKNOWN_TYPE",
  HUMAN: "HUMAN",
  SYSTEM: "SYSTEM",
  AGENT: "AGENT",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type UserType = typeof UserType[keyof typeof UserType];

export namespace UserType {
  export type UNKNOWN_TYPE = typeof UserType.UNKNOWN_TYPE;
  export type HUMAN = typeof UserType.HUMAN;
  export type SYSTEM = typeof UserType.SYSTEM;
  export type AGENT = typeof UserType.AGENT;
  export type UNRECOGNIZED = typeof UserType.UNRECOGNIZED;
}

export interface User {
  id: string;
  email?: string | undefined;
  name?: string | undefined;
  username: string;
  /** @deprecated */
  profilePicUrl?: string | undefined;
  userType: UserType;
  roles: User_PlatformRole[];
  profilePicture: FileAttachment | undefined;
  banner: FileAttachment | undefined;
  createdAt: string | undefined;
  isSuspended: boolean;
  isPlatformPolice: boolean;
}

export const User_PlatformRole = {
  UNKNOWN_ROLE: "UNKNOWN_ROLE",
  SUPER_ADMIN: "SUPER_ADMIN",
  ADMIN: "ADMIN",
  TRUST_AND_SAFETY_MANAGER: "TRUST_AND_SAFETY_MANAGER",
  MANAGER: "MANAGER",
  SUPPORT: "SUPPORT",
  TESTER: "TESTER",
  SEO_MANAGER: "SEO_MANAGER",
  TEMPLATE_USER: "TEMPLATE_USER",
  MARKETPLACE_MANAGER: "MARKETPLACE_MANAGER",
  DEVELOPER: "DEVELOPER",
  FINANCE_MANAGER: "FINANCE_MANAGER",
  RESOLUTION_CENTER_MANAGER: "RESOLUTION_CENTER_MANAGER",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type User_PlatformRole = typeof User_PlatformRole[keyof typeof User_PlatformRole];

export namespace User_PlatformRole {
  export type UNKNOWN_ROLE = typeof User_PlatformRole.UNKNOWN_ROLE;
  export type SUPER_ADMIN = typeof User_PlatformRole.SUPER_ADMIN;
  export type ADMIN = typeof User_PlatformRole.ADMIN;
  export type TRUST_AND_SAFETY_MANAGER = typeof User_PlatformRole.TRUST_AND_SAFETY_MANAGER;
  export type MANAGER = typeof User_PlatformRole.MANAGER;
  export type SUPPORT = typeof User_PlatformRole.SUPPORT;
  export type TESTER = typeof User_PlatformRole.TESTER;
  export type SEO_MANAGER = typeof User_PlatformRole.SEO_MANAGER;
  export type TEMPLATE_USER = typeof User_PlatformRole.TEMPLATE_USER;
  export type MARKETPLACE_MANAGER = typeof User_PlatformRole.MARKETPLACE_MANAGER;
  export type DEVELOPER = typeof User_PlatformRole.DEVELOPER;
  export type FINANCE_MANAGER = typeof User_PlatformRole.FINANCE_MANAGER;
  export type RESOLUTION_CENTER_MANAGER = typeof User_PlatformRole.RESOLUTION_CENTER_MANAGER;
  export type UNRECOGNIZED = typeof User_PlatformRole.UNRECOGNIZED;
}

export interface UserStat {
  userId: string;
  moneyEarned24Hours: Money | undefined;
  moneyEarned30Days: Money | undefined;
  moneyEarned7Days: Money | undefined;
  moneyEarnedLifetime: Money | undefined;
}

export interface UserPresence {
  userId: string;
  lastSeenAt?: string | undefined;
}
